require("./appConfigPhone.less");
var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('auth-list')
        ko.components.register('auth-list', {
            viewModel: function (params) {
                var $this = this;
                var appId = location.hash.replace("#/appConfig/", "");
                $this.appId = appId;
                common.fetch("/auth/app/account/getAppAccounts", {
                    type: "GET", query: {appId:appId},
                    handleError: function (data) {
                        //$this.errorMessage(data.message);
                    },
                    success: function (result) {
                        $this.datas = result.data;
                    }
                })
                $this.close = function(){
                    common.redirectTo("/#/appList")
                }
            },
            template: require("./template/AuthList.html")
        });
        document.createElement('auth-card')
        ko.components.register('auth-card', {
            viewModel: function (params) {
                var $this = this;
                $this.app = params.app;
                $this.appCode = params.appCode;
                $this.appId = params.appId;
                $this.isenable = ko.observable("");
                $this.isenable(common.termRender(params.app.enable,$this.app.startDate,$this.app.endDate));
                if(params.app.linkType=="OWNER"){
                    $this.type=_i18n('拥有')
                }else if(params.app.linkType=="USERGRANT"){
                    $this.type=_i18n("他人委托")
                }else{
                    $this.type=_i18n("可使用")
                }
                $this.lastTime = params.app.lastUseTime&&params.app.lastUseTime!=0?_i18n(" 最后访问：")+common.timestampToTime(10000000000):"";
                $this.manage = function(){
                    common.redirectTo("/#/manageAuth/"+$this.app.accountName+"/"+$this.appCode+"/"+$this.appId)
                }
            },
            template: require("./template/AuthCard.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/AuthList.js
// module id = 136
// module chunks = 0